import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63a9a30a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "my-3 p-3 bg-app position-relative" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "fz-sm-34 fz-md-52 ms-3 fw-bold nunito position-absolute" }, " Make a Premium Calendar ", -1));
const _hoisted_3 = { class: "text-white d-flex align-items-center justify-content-end mb-3" };
const _hoisted_4 = {
    key: 0,
    class: "info mx-auto w-md-50 text-center mt-md-5 nunito fz-18 lh-22"
};
const _hoisted_5 = {
    key: 1,
    class: "info mx-auto w-lg-50 text-center mt-5 nunito fz-18 lh-22"
};
const _hoisted_6 = { class: "d-flex flex-column flex-md-row justify-content-center mt-0" };
const _hoisted_7 = {
    key: 0,
    class: "free mt-5"
};
const _hoisted_8 = { class: "plan px-sm-2 mx-sm-4 text-center" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "text-center my-4 nunito fz-32 fw-bold" }, "Basic", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "fw-bold fz-22 poppins price" }, "Free", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", { class: "mb-3" }, null, -1));
const _hoisted_12 = { class: "text-start mx-4" };
const _hoisted_13 = /*#__PURE__*/ _createStaticVNode("<p class=\"nunito fz-16 my-0\" data-v-63a9a30a><i class=\"fz-18 bi bi-check text-green me-1\" data-v-63a9a30a></i>Make as many calendars as you want</p><p class=\"nunito fz-16 my-0\" data-v-63a9a30a><i class=\"fz-18 bi bi-x text-red\" data-v-63a9a30a></i>Calendars have watermarks</p><p class=\"nunito fz-16 my-0\" data-v-63a9a30a><i class=\"fz-18 bi bi-x text-red\" data-v-63a9a30a></i>Basic template only</p>", 3);
const _hoisted_16 = { class: "plan px-sm-2 premium mt-5 mx-sm-4 text-center" };
const _hoisted_17 = /*#__PURE__*/ _createStaticVNode("<img class=\"premium-title-img mt-4 mb-3\" src=\"/images/premium-icon.png\" data-v-63a9a30a><h2 class=\"text-center mb-1 nunito fz-32 fw-bold\" data-v-63a9a30a> Premium </h2><h3 class=\"text-center mb-1 nunito fz-22 fw-bold\" data-v-63a9a30a>1-Year Pass </h3><p class=\"fw-bold fz-24 poppins price\" data-v-63a9a30a>$19.95<span class=\"fz-12\" data-v-63a9a30a> USD</span></p><p class=\"fz-18\" data-v-63a9a30a>One-time payment. No subscription</p><hr class=\"mb-3\" data-v-63a9a30a>", 6);
const _hoisted_23 = { class: "text-start mx-4" };
const _hoisted_24 = /*#__PURE__*/ _createStaticVNode("<p class=\"nunito fz-16 my-0\" data-v-63a9a30a><i class=\"fz-18 bi bi-check text-green me-1\" data-v-63a9a30a></i>Make as many calendars as you want</p><p class=\"nunito fz-16 my-0\" data-v-63a9a30a><i class=\"fz-18 bi bi-check text-green me-1\" data-v-63a9a30a></i>Make calendars without watermarks</p><p class=\"nunito fz-16 my-0\" data-v-63a9a30a><i class=\"fz-18 bi bi-check text-green me-1\" data-v-63a9a30a></i>Access to premium templates</p>", 3);
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "info mx-auto w-lg-50 text-center mt-5 nunito fz-18 lh-22" }, [
    /*#__PURE__*/ _createTextVNode(" Already have a premium account? "),
    /*#__PURE__*/ _createElementVNode("a", {
        class: "text-blue text-decoration-underline",
        href: "/login"
    }, "log in here")
], -1));
import { useRouter, useRoute } from 'vue-router';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
//import { ReImg } from '../modules/reimg';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BuyDialog',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const calendarSettingsStore = useCalendarSettingsStore();
        function downloadCalendar() {
            if (calendarSettingsStore.calendarCanvas != null) {
                calendarSettingsStore.saveImage(calendarSettingsStore.calendarCanvas.toDataURL(), 'calendar');
            }
        }
        function buyNow() {
            //window.location.href = '/subscription-checkout?coupon=CHRISTMAS2022';
            window.location.href = '/subscription-checkout';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn-close text-primary ms-2 me-1",
                        "aria-label": "Close",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).back()))
                    })
                ]),
                (_unref(route).name == 'makeFree')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, " You are about to make a free calendar, free calendars show a small watermark that you can remove by upgrading to a premium account. "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, " Your calendar design uses a premium template, become a premium user by purchasing a premium account! ")),
                _createElementVNode("div", _hoisted_6, [
                    (_unref(route).name == 'makeFree')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _hoisted_10,
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    _createElementVNode("p", {
                                        class: "mt-5 text-decoration-underline text-blue text-center cursor-pointer",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (downloadCalendar()))
                                    }, "Make free calendar")
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_23, [
                            _hoisted_24,
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-primary my-4 w-100 fz-18 button-blue poppins",
                                onClick: _cache[2] || (_cache[2] = ($event) => (buyNow()))
                            }, "Purchase Now")
                        ])
                    ])
                ]),
                _hoisted_27
            ]));
        };
    }
});
